import type { HttpErrorResponse } from '@angular/common/http';

import { createSingleEntityStore, ngrxEvent, pipeState } from '@core/ngrx-legacy';

type State = {
  candidatesCount: number;
};

const { actions, namespace, reducer, selectors } = createSingleEntityStore<State>()(
  'GdprAutoConsent',
  {
    customActions: adapter => ({
      loadCandidateCount: state => adapter.markAsPending(state),
      loadCandidateCountSuccess: (state, payload: State) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      loadCandidateCountFailed: (state, payload: { error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error),

      schedule: ngrxEvent<void>(),
      scheduleSuccess: ngrxEvent<{ uuid: string }>(),
      scheduleFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
    }),
  },
);

const GdprAutoConsentActions = <
  Pick<
    typeof actions,
    | 'loadCandidateCount'
    | 'loadCandidateCountSuccess'
    | 'loadCandidateCountFailed'
    | 'schedule'
    | 'scheduleSuccess'
    | 'scheduleFailed'
  >
>actions;

export {
  GdprAutoConsentActions,
  selectors as GdprAutoConsentSelectors,
  namespace as GdprAutoConsentNamespace,
  reducer as GdprAutoConsentReducer,
};
